import { Box, Skeleton } from '@mui/material';

export const ProductCardPlaceholder = () => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1.5,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          paddingBottom: '120%', // 1.2 * width = 120% height
          overflow: 'hidden',
        }}
      >
        <Skeleton
          variant='rectangular'
          width='100%'
          height='100%'
          sx={{ position: 'absolute', top: 0, left: 0 }}
        />
      </Box>

      <Skeleton variant='rectangular' width='100%' height={20} />
      <Skeleton variant='rectangular' width='60%' height={20} />
      <Skeleton variant='rectangular' width='70%' height={45} />
    </Box>
  );
};
